module.exports = __webpack_public_path__ + "static/netAD-Figure2-8b1c0784f383ac9a40ef2af2c5a48436.png";